import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import * as tcw from "@tylertech/forge";
import { IntentsModule } from "@tylertech/intents-module";
import { LgdTextAreaModule, LgdTextModule } from "@tylertech/lgd-reactive-forms";
import * as components from "./components";
import { ApprovalLogService, CommonDialogsService } from "./services";

tcw.defineIconComponent();

const angularModules = [
    BrowserModule,
    CommonModule,
    FlexModule,
    FlexLayoutModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    DragDropModule,
    MatCardModule,
    MatDialogModule,
    MatGridListModule,
    MatIconModule,
    MatListModule,
    MatProgressBarModule
];

const lgdModules = [
    CommandsModule,
    CoreModule,
    CommonComponentsModule,
    IntentsModule,
    LgdTextModule,
    LgdTextAreaModule,
];

const exportedComponents = [
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules
    ],
    declarations: [
        ...exportedComponents,
        components.AddressComponent,
        components.AddressDialogComponent,
        components.AlertDialogComponent,
        components.CommentDialogComponent,
        components.ConfirmDialogComponent,
        components.DragAndDropDialogComponent,
        components.DragAndDropGroupComponent,
        components.DragAndDropGroupDialogComponent,
        components.DragAndDropGroupListComponent,
        components.DragAndDropListComponent,
        components.IntentActionDialogComponent,
        components.NumberDialogComponent,
        components.PromptDialogComponent,
        components.SaveDialogComponent,
        components.SavingDialogComponent,
    ],
    exports: exportedComponents,
    providers: [
        CommonDialogsService,
        ApprovalLogService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonDialogsModule { }
